import { render, staticRenderFns } from "./ImageWithSwiper.vue?vue&type=template&id=7ed08b50&scoped=true&"
import script from "./ImageWithSwiper.vue?vue&type=script&lang=js&"
export * from "./ImageWithSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithSwiper.vue?vue&type=style&index=0&id=7ed08b50&prod&lang=postcss&scoped=true&"
import style1 from "./ImageWithSwiper.vue?vue&type=style&index=1&id=7ed08b50&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed08b50",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
